import { Box, Icon, Text, ToggleGroup } from '@betterment/samba-react';

import { type ColorMode, useColorMode } from './color-mode-state';

export const ColorModeControls = () => {
  const { matchSystem, setColorMode } = useColorMode();

  return (
    <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.50' }}>
      <Text variant="text25">Color mode (experimental):</Text>
      <ToggleGroup
        onValueChange={(value: ColorMode | 'system') => {
          if (value === 'system') {
            matchSystem();
          } else {
            setColorMode(value);
          }
        }}
        spacing="default"
        type="single"
      >
        <ToggleGroup.Item value="light" aria-label="Light theme">
          <Icon name="Lightning" size="inline" />
        </ToggleGroup.Item>
        <ToggleGroup.Item value="dark" aria-label="Dark theme">
          <Icon name="LightningCrossout" size="inline" />
        </ToggleGroup.Item>
        <ToggleGroup.Item value="system" aria-label="Match system">
          <Icon name="ArrowCircle" size="inline" />
        </ToggleGroup.Item>
      </ToggleGroup>
    </Box>
  );
};
